import {Controller} from '@stubhub/react-store-provider';

import {showBrokerInfoSelector, contentSelector} from './selectors';

const NAMESPACE = 'buildyourorder';

const controller = new Controller({
  namespace: NAMESPACE,
  mapStateToProps(state) {
    return {
      ticketTraits: contentSelector(state),
      showBrokerInfo: showBrokerInfoSelector(state),
    };
  },
});

export default controller;
